<template>
  <section class="pos-detail">
    <p slot="title">
      <span>{{ billMonth }}</span
      >月Pos数据渝欧主体门店
      <span class="pos-status">{{ status }}</span>
    </p>
    <descriptions
      title="基本信息"
      :data="basicPosInfo"
      v-if="basicPosInfo.length != 0"
    ></descriptions>
    <Tabs value="shopInfo" style="margin-top: 30px;">
      <TabPane label="商品信息" name="shopInfo">
        <Table
          border
          :columns="shopColumns"
          :data="shopDataSource"
          ref="shopTable"
        ></Table>
      </TabPane>
      <TabPane label="操作日志" name="operationLog">
        <Table
          border
          :columns="operationColumns"
          :data="operationDataSource"
          ref="operationTable"
        ></Table>
      </TabPane>
    </Tabs>
    <Modal
      footer-hide
      title="查看图片"
      v-model="visiable"
      class="vertical-center-modal"
    >
      <div style="text-align: center;max-width: 300;">
        <img :src="photoUrl" width="400" />
      </div>
    </Modal>
  </section>
</template>

<script>
import descriptions from "@/views/shopTask/components/descriptions";
import * as CONSTANTS from "./validate/constants";

const initFormValidate = {
  receivePerson: "",
  receiveMobile: "",
  address: "",
  addr: "",
  valid: "0"
};
const infoKeys = ["basicPosInfo"];
const BOOLEAN_TEXT = {
  true: "是",
  false: "否"
};

export default {
  name: "pos-detail",
  components: {
    descriptions
  },
  data() {
    return {
      visiable: false,
      photoUrl: "",
      details: {},
      shopDataSource: [],
      operationDataSource: [],
      basicPosInfo: [],
      shopColumns: [
        {
          title: "序号",
          type: "index",
          width: 100
        },
        {
          title: "商品信息",
          key: "detailViewList",
          minWidth: 200,
          render: (h, params) => {
            const { row } = params;
            return h("div", [
              h("img", {
                attrs: { src: row.coverImgUrl },
                style: {
                  width: "40px",
                  height: "40px",
                  borderRadio: "8px"
                },
                on: {
                  click: () => this.openSkuImg(row.coverImgUrl)
                }
              }),
              h("span", null, row.skuName)
            ]);
          }
        },
        {
          title: "线下POS（听）",
          key: "erpCode",
          minWidth: 160,
          render: (h, params) => {
            const { row } = params;
            return h("div", null, row.pkgUnitDesc);
          }
        }
      ],
      operationColumns: [
        {
          title: "时间",
          key: "updatetime"
        },
        {
          title: "操作人",
          key: "operatorName",
          minWidth: 80
        },
        {
          title: "备注",
          key: "ext",
          minWidth: 160
        }
      ]
    };
  },
  created() {
    this.getPosQueryDetail();
  },
  methods: {
    openSkuImg(url) {
      this.visiable = true;
      this.photoUrl = url;
    },
    async getPosQueryDetail() {
      const { id } = this.$route.query;
      const params = {
        id: id
      };
      const { data } = await this.$api["posQueryDetail"](params);
      this.details = data;
      this.status = this.switchStatus(data.status) || "";
      this.dataSource = data.optLogList || [];
      this.billMonth = data.billMonth ? data.billMonth.replace("-", "年") : "";
      this.shopDataSource = data.detailViewList || [];
      this.operationDataSource = data.optLogList || [];

      const infos = infoKeys.reduce(
        (prev, curr) => ({
          ...prev,
          [curr]: this.formDetails(curr, CONSTANTS[curr])
        }),
        {}
      );

      this.basicPosInfo = infos.basicPosInfo || [];
    },
    switchStatus(status) {
      switch (status) {
        case "1":
          return "待审核";
        case "20":
          return "审核通过";
        case "10":
          return "审核拒绝";
        case "-255":
          return "已作废";
        default:
          return "";
      }
    },
    formDetails(type, labels) {
      const { details } = this;
      const actionTypes = {
        common: values =>
          Object.entries(values).reduce(
            (prev, [key, label], rowKey) =>
              details[key] == undefined
                ? prev
                : [
                    ...prev,
                    {
                      label,
                      values: ![true, false].includes(details[key])
                        ? details[key]
                        : BOOLEAN_TEXT[details[key]] || null,
                      rowKey,
                      type: this.selectPhotoType(key)
                    }
                  ],
            []
          )
      };
      return actionTypes.common(labels);
    },
    selectPhotoType(v) {
      return v == "imgLecienceUrl" ? "photo" : "";
    }
  }
};
</script>

<style scoped>
.pos-detail {
  padding: 0 20px;
}

.pos-status {
  margin-left: 5px;
  height: 19px;
  background: #fce5e6;
  line-height: 1;
  border-radius: 4px;
  display: inline-block;
  padding: 0 4px;
  line-height: 19px;
  font-weight: 600;
  font-size: 12px;
  color: #e7212b;
}
</style>



// WEBPACK FOOTER //
// src/views/shopTask/shopPosDetail.vue